import { render, staticRenderFns } from "./QuestionTargetPos.vue?vue&type=template&id=706f1499&scoped=true"
import script from "./QuestionTargetPos.vue?vue&type=script&lang=js"
export * from "./QuestionTargetPos.vue?vue&type=script&lang=js"
import style0 from "./QuestionTargetPos.vue?vue&type=style&index=0&id=706f1499&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f1499",
  null
  
)

export default component.exports